import React from 'react';
import {useSelector} from 'react-redux';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';

import ContentView from '../ContentView';
import InfoView from '../InfoView';
import useStyles from '../../../shared/jss/common/common.style';
import {AppState} from '../../../redux/store';
import HorLightNav from './HorLightNav';
import defaultConfig from '../../utility/ContextProvider/defaultConfig';

const useStyle = makeStyles(() => ({
  appAuth: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    height: '100vh',
    backgroundColor: defaultConfig.theme.palette.background,

    '& .scrollbar-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .main-content-view': {
      padding: 20,
    },
    '& .footer': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
}));

interface CremaLayoutProps {}

const CremaLayout: React.FC<CremaLayoutProps> = () => {
  useStyles();
  const {user} = useSelector<AppState, AppState['auth']>(({auth}) => auth);

  const classes = useStyle();
  return (
    <>
      <InfoView />
      {user ? (
        <>
          <HorLightNav />
        </>
      ) : (
        <Box className={classes.appAuth}>
          <ContentView />
        </Box>
      )}
    </>
  );
};

export default React.memo(CremaLayout);
